module.exports = __webpack_public_path__ + "static/media/voiceAssistant.0bc7f54f.svg";